export const visit = (vm, at) => {
at({ "en": { "featureTables": { "compare": { "screenReader": { "featureAvailable": "feature available", "featureUnavailable": "feature unavailable" } } } } });
};